/**
 * Copyright (c) 2022, ResMed Inc. All rights reserved.
 */

import {positions} from "react-alert";

/**
 * Common alert style
 */
const commonStyle = {
    textTransform: 'none'
}

/**
 * Configuration for AlertProvider in index.js
 */
export const alertOptions = {
    timeout: 5000,
    position: positions.BOTTOM_CENTER
}

/**
 * Static class for Alert Styles
 */
export default class AlertStyle {

    static common(message) {
        return <div style={commonStyle}>{message}</div>;
    }

}